import React from 'react'

class Vimeo extends React.Component {
  componentDidMount() {
    // We need to find the actual DOM node this component rendered (our iframe)
    // We need to create an instance of VimeoPlayer
    // https://github.com/vimeo/player.js/issues/32#issuecomment-255742059
    const VimeoPlayer = require('@vimeo/player').default // eslint-disable-line
    this.player = new VimeoPlayer(this.vimeoEl)
    this.player.setColor('#fec077')
    this.player.on('play', () => {
      const { onPlay, url, fullscreenOnPlay } = this.props
      if (onPlay) onPlay(url)

      if (fullscreenOnPlay) {
        this.player.requestFullscreen()
      }
    })
  }

  /**
   * We need to expose the pause function of VimeoPlayer
   * to instances of this component
   */
  pause() {
    // https://github.com/vimeo/player.js/issues/42
    this.player.play().then(() => {
      this.player.pause()
    })
  }

  play() {
    this.player.play()
  }

  render() {
    const { url, style } = this.props
    return (
      <iframe
        ref={(vimeoEl) => {
          this.vimeoEl = vimeoEl
        }}
        id={url}
        title="carousel-video"
        src={url}
        width="100%"
        height="100%"
        frameBorder="0"
        style={style}
        allowFullScreen
        allow="autoplay"
      />
    )
  }
}

export default Vimeo
